const DATAROOM_TENANT_CODES = ['dealvdr', '17g5', 'investorset', 'verisend', 'researchroom', 'loansend'] as const;

export type DataroomTenant = typeof DATAROOM_TENANT_CODES[number];

export const DATAROOM_TENANTS: DataroomTenant[] = [...DATAROOM_TENANT_CODES];
